import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Modal } from 'bootstrap/dist/js/bootstrap';

const ModalStyled = styled.div`
	background: rgba(0, 0, 0, 0.4);
`;

export default function CloseFiscalYearModal({ financialYear, nextYear, nextYearHasOpeningEntry, onConfirm, onClose }) {
	const modalRef = useRef(null);
	const [copyBalances, setCopyBalances] = useState(true);

	const canCarryOver = !!nextYear && nextYear.status === 'open' && !nextYear.current_operation;

	useEffect(() => {
		const modal = new Modal(modalRef.current, { backdrop: false });

		const hiddenEvent = (e) => {
			modal._element.removeEventListener('hidden.bs.modal', hiddenEvent);
			modal._element.removeEventListener('shown.bs.modal', hiddenEvent);
			modal.dispose();
			onClose();
			document.body.style.overflow = 'auto';
			document.body.style.paddingRight = '0';
		};

		modal._element.addEventListener('hidden.bs.modal', hiddenEvent);
		modal.show();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleConfirm = () => {
		const value = canCarryOver ? copyBalances : false;
		onConfirm(value);
		Modal.getInstance(modalRef.current).hide();
	};

	return (
		<ModalStyled className="modal" tabIndex="-1" ref={modalRef}>
			<div className="modal-dialog modal-md">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">
							<i className="bi bi-lock me-1"></i>
							Cerrar ejercicio {financialYear.year}
						</h5>
						<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
					</div>
					<div className="modal-body">
						<p>
							Vas a cerrar el ejercicio fiscal <strong>{financialYear.year}</strong>. Mientras esté cerrado no se podrán crear ni modificar asientos contables hasta que se reabra.
						</p>

						{ canCarryOver && (
							<>
								<hr/>
								<p className="mb-2">
									<strong>Traspasar saldos al ejercicio {nextYear.year}</strong>
								</p>
								<p className="text-muted small mb-2">
									Puedes copiar los saldos finales de {financialYear.year} como saldos iniciales del ejercicio {nextYear.year}.
								</p>
								<div className="form-check form-switch">
									<input
										type="checkbox"
										className="form-check-input"
										role="switch"
										id="copyBalancesSwitch"
										checked={copyBalances}
										onChange={(e) => setCopyBalances(e.target.checked)}
									/>
									<label className="form-check-label" htmlFor="copyBalancesSwitch">
										Copiar saldos finales al ejercicio {nextYear.year}
									</label>
								</div>

								{ copyBalances && nextYearHasOpeningEntry && (
									<div className="alert alert-warning mt-2 mb-0 py-2 small">
										<i className="bi bi-exclamation-triangle me-1"></i>
										El ejercicio {nextYear.year} ya tiene un asiento de apertura. Si copias los saldos, se sobrescribirá.
									</div>
								) }
							</>
						) }

						{ !canCarryOver && nextYear && (
							<>
								<hr/>
								<p className="text-muted small mb-0">
									{ nextYear.status !== 'open'
										? `El ejercicio ${nextYear.year} está cerrado, no se pueden traspasar saldos.`
										: `El ejercicio ${nextYear.year} tiene una operación en curso, no se pueden traspasar saldos ahora.`
									}
								</p>
							</>
						) }
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-sm btn-light" data-bs-dismiss="modal">Cancelar</button>
						<button type="button" className="btn btn-sm btn-primary text-white" onClick={handleConfirm}>
							{ canCarryOver && copyBalances
								? 'Cerrar y copiar saldos'
								: 'Cerrar ejercicio'
							}
						</button>
					</div>
				</div>
			</div>
		</ModalStyled>
	);
}
